const ImagesFactory = require('../factory/images');
const DesignFacade = require('../facade/design/design');
const checkClipPath = require('./images-sanitize/clip-path-sanitize');
const { isDataURL } = require('../../helpers/dataUrl');
import { constants as config } from '@config';

module.exports = {
  base64Sanitize: function (str) {
    const base64Exp = /(<image[^>]*xlink:href=")(data:[^;]*;base64[^"]*)("[^>]*)/ig;

    return str.replace(base64Exp, function (match, attr1, url, attr2) {
      const id = getId(match);
      const hash = ImagesFactory.getImageHash(id, url);
      ImagesFactory.setBase64(hash, url);
      return attr1 + hash + attr2;
    });
  },

  base64Load: function (str) {
    const base64Exp = /(<image[^>]*xlink:href=")([^"]*)("[^>]*)/ig;

    return str.replace(base64Exp, function (match, attr1, base64Id, attr2) {
      const base64Image = ImagesFactory.getBase64(base64Id);
      return base64Image ? attr1 + base64Image + attr2 : match;
    });
  },

  preLoadImagesSanitize: function (str) {
    const imageExp = /<image([^>]*)xlink:href="([^"]*)"([^>]*)>([^<]*)<\/image>/g;
    const emptyImgExp = /<image([^>]*)xlink:href="([^"]*)"([^>]*)\/>/g;

    str = str.replace(imageExp, function (match, attr1, url, attr2, content) {
      return processMatch(match, attr1, url, attr2, content);
    });

    return str.replace(emptyImgExp, function (match, attr1, url, attr2) {
      return processMatch(match, attr1, url, attr2);
    });

    function processMatch (match, attr1, url, attr2, content) {
      if (ImagesFactory.isBlacklisted(getId(match), url)) { return ''; }

      const hasNullUrl = url === 'null';
      if (hasNullUrl || (isDataURL(url) && typeof ImagesFactory.getImageUrl(getId(match), url) === 'undefined')) { return ''; }

      const skippedUrls = ['/videothumbs/', '/video/'];
      if (skippedUrls.find(s => url.includes(s))) return match;
      if (attr1.indexOf('data-url=') > -1 || attr2.indexOf('data-url=') > -1 || isDataURL(url)) { return match; }

      if (url) {
        const originalUrl = specialCharsSanitize(ImagesFactory.getOriginalUrl(url) || url);
        const imageHash = getAttribute(match, 'data-hash')

        ImagesFactory.setImageUrl(getId(match), originalUrl, imageHash);
      }

      return content
        ? '<image' + attr1 + 'data-url="' + url + '"' + attr2 + '>' + content + '</image>'
        : '<image' + attr1 + 'data-url="' + url + '"' + attr2 + '/>';
    }

    function specialCharsSanitize (source) {
      const specialCharsReplacement = {
        '&': /&amp;/g
      };

      return Object.entries(specialCharsReplacement)
        .reduce((result, [char, regex]) => result.replace(regex, char), source);
    }
  },

  postLoadBackgroundSanitize: function (content) {
    const $background = $(content).find('svg > g.background');
    const $backgroundImage = $background.find('image');
    let $backgroundRect = $background.find('rect');

    setInitialBackground();
    $backgroundImage.length && processImageBackground();
    processRectBackground();

    return content;

    function setInitialBackground () {
      if ($backgroundImage.prevObject.length && INKIVE.C.initialBackgroundImageSource) {
        DesignFacade.set('background', { source: INKIVE.C.initialBackgroundImageSource });
      }
    }

    function processImageBackground () {
      const hasSizeProperties = parseFloat($backgroundImage[0].getAttribute('width')) &&
        parseFloat($backgroundImage[0].getAttribute('height'));

      hasSizeProperties && applyBackground();
      hasSizeProperties || addBackgroundDimensions();

      function applyBackground () {
        const attrs = {
          x: $backgroundImage.attr('x'),
          y: $backgroundImage.attr('y'),
          width: $backgroundImage.attr('width'),
          height: $backgroundImage.attr('height'),
          class: $backgroundImage.attr('class')
        };

        let savedImageVersion = ImagesFactory.getImageUrl($backgroundImage.get(0));
        if (!savedImageVersion) {
          savedImageVersion = $backgroundImage.attr('xlink:href');
          savedImageVersion || $backgroundImage.remove();
          return;
        }

        $backgroundImage.removeAttr('data-url');
        DesignFacade.set('background', {
          attrs,
          source: savedImageVersion,
          smart_load: true,
          is_initial_load: true,
          smart_asset: $backgroundImage.attr(config.smartAssets.attributes.definedAsset),
          custom_placeholder: $backgroundImage.attr(config.smartAssets.attributes.userInput)
        });
      }

      function addBackgroundDimensions () {
        const image = new Image();
        image.src = INKIVE.Helpers.getCORSSecureUrl($backgroundImage.data('url'));

        $(image).load(function () {
          const tool = INKIVE.Tool.getInstance();
          const canvas = tool.editor.canvas;
          const size = INKIVE.DesignFacade.setters.background._getBackgroundSize(image);

          $backgroundImage.attr('x', (canvas.contentW - size.width) / 2);
          $backgroundImage.attr('y', (canvas.contentH - size.height) / 2);
          $backgroundImage.attr('width', size.width);
          $backgroundImage.attr('height', size.height);

          applyBackground();
        });
      }
    }

    function processRectBackground () {
      if (!$backgroundRect.length) {
        return;
      }
      $backgroundRect.attr('x', 0);
      $backgroundRect.attr('y', 0);
      $backgroundRect.attr('width', '100%');
      $backgroundRect.attr('height', '100%');
      $backgroundRect.attr('id', config.background.color);
    }
  },

  postLoadImagesSanitize: function (content) {
    const tool = INKIVE.Tool.getInstance();
    const canvas = tool.editor.canvas;
    const designId = INKIVE.Tool._current_design_id;

    $('image.dummy').remove();

    $(content).find('image').each(function () {
      const element = this;
      const $image = $(this);

      const passImage = element.getAttribute('xlink:href') ||
        $image.parent().is('.background') ||
        $image[0].getAttribute('opacity') === '0';

      if (passImage) { return; }

      const savedImageVersion = ImagesFactory.getImageUrl(element);

      if (savedImageVersion && savedImageVersion.startsWith('http') && !element.dataset.url) {
        element.dataset.url = savedImageVersion;
      } else if (savedImageVersion && !element.dataset.hash) {
        element.dataset.hash = savedImageVersion;
      }

      if (!savedImageVersion) {
        element.getAttribute('xlink:href') || $image.remove();
        return;
      }

      const inOrderLoadOptions = INKIVE.Image.Helpers.getInOrderLoadOptions(savedImageVersion, {
        width: element.getAttribute('width'),
        height: element.getAttribute('height')
      });

      const elementDetails = INKIVE.Helpers.elementHelper(element.parentElement);
      if (
        !elementDetails.isIcon() &&
        !elementDetails.isLogo() &&
        !INKIVE.Helpers.elementHelper(element).isSticker()
      ){
        element.removeAttribute('data-url');
      }

      INKIVE.Image.Helpers.loadImageOptions(inOrderLoadOptions, function (img) {
        if (designId !== INKIVE.Tool._current_design_id) { return; }

        const isImageElement = !$image.is('.logo') &&
          !$image.parent().is('.logo') &&
          !$image.is('.icon') &&
          !$image.parent().is('.icon');

        const id = isImageElement
          ? element.getAttribute('id')
          : $image.closest('.element')[0].getAttribute('id');

        const data = isImageElement
          ? { source: { url: img.src, smart_load: false } }
          : { thumb_src: img.src, smart_load: false };

        DesignFacade.set(id, _.extend(data, { is_initial_load: true }));

        canvas.runExtensions('fixImageSize', {
          elem: element,
          skipSelection: true
        });
      });

      checkClipPath.sanitize(canvas, content, element);
    });

    checkClipPath.removeUnusedClippaths(content);
    return content;
  },

  setImagePositionedAsBackground: function ($content) {
    const $background = $content.find('g.background');
    const replacementImage = $content.find('[data-position="background"]');

    if (replacementImage.length && !$background.find('image').length) {
      const url = replacementImage.attr('data-url');

      replacementImage.detach();
      replacementImage.attr('data-position', '');
      replacementImage.attr('data-url', '');
      replacementImage.attr('id', config.background.image);
      url && replacementImage.attr('xlink:href', url);

      svgedit.recalculate.cloneTransfromList($background[0], replacementImage[0]);
      svgedit.recalculate.recalculateDimensions(replacementImage[0]);

      $background.append(replacementImage);
    }

    $background.length && $background[0].removeAttribute('transform');

    return $content;
  }
};

function getAttribute (tag, attribute) {
  const regex = ` ${attribute}="([^"]*)"`;
  const idMatch = tag.match(regex);

  return idMatch?.[1];
}

function getId (tag) {
  return getAttribute(tag, 'id');
}
